import React, {Component} from "react";
import {Row, Col, Collapse} from 'reactstrap';
import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css';
import {mapType} from '../../../../../utils/constants';
import '../Review.css';

export default class ReviewOfficeHierarchy extends Component {

    constructor(props) {
       super(props);
       this.state = {
           isOfficeHierarchyOpened: false,
           isAddedAdminsOpened: false
       }
    }

    render() {
        let { selectedFlaggedAdminOffice, allOfficesWithInvitations, officeHierarchy } = this.props.orgChart;
        let {isOfficeHierarchyOpened, isAddedAdminsOpened} = this.state;
        let noOfOfficesAdminAdded = allOfficesWithInvitations.filter(officesWithInvitations => officesWithInvitations.invitedUsers.length > 0).length;
        return (<div>
                <div className="review-sub-section">
                    <Row>
                        <Col sm="11" md="11" className="review-sub-section-heading orgChartReview"> Organizational Chart Hierarchy </Col>
                        <Col sm="1" md="1" className={isOfficeHierarchyOpened ? 'rotate-arrow' : 'text-center'}> 
                        <i className={(isOfficeHierarchyOpened ? 'flaticon-down-arrow ' : 'flaticon-down-arrow').concat(' review-flaticon-down-arrow cursor-pointer')}  
                            onClick={ () => {
                            this.setState({isOfficeHierarchyOpened : !isOfficeHierarchyOpened});
                        }}/>
                        </Col>
                    </Row>
                    <Collapse isOpen={isOfficeHierarchyOpened}>
                    <div className="mt30">
                        <SortableTree
                            treeData={officeHierarchy}
                            canDrag={false}
                            canDrop={false}
                            onChange={() => {}}
                            generateNodeProps={({ node, path }) => {
                                return {
                                    className: 'drag-node',
                                };
                            }}
                            canDrag={({ node }) => !node.dragDisabled}
                            isVirtualized={false}
                        />
                    </div>
                    </Collapse>
                </div>
                
            {/* <div className="review-sub-section">
                <span className="review-sub-section-heading"><span>Your office: </span><span style={{ fontWeight: '400' }}>
                    {(selectedFlaggedAdminOffice && selectedFlaggedAdminOffice.value) ? selectedFlaggedAdminOffice.value : ''}
                </span></span>
            </div> */}
                </div>
                )
    }
}
